import React from "react";
import Link from "gatsby-link";

const Nav = () => (
	<nav className="main-nav">
		<button className="menu-toggle">
			<span className="screen-reader-text">Click to toggle the menu</span>
		</button>
		<ul>
			<li>
				<Link to="/">Home</Link>
			</li>
			<li>
				<Link to="/about">About</Link>
			</li>
			<li>
				<Link to="/work">Work</Link>
			</li>
		</ul>
	</nav>
);

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/index.js